import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Container, Box, Tab, Tabs } from '@mui/material';
import InboundStats from "./inboundStats";
import OutboundStats from './outboundStats';

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <Box role="tabpanel" hidden={value !== index}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function StreamStats() {
  const [value, setValue] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setValue(0);
    }, 200);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Outbound" {...a11yProps(0)} />
              <Tab label="Inbound" {...a11yProps(0)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <OutboundStats />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <InboundStats />
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
}
